import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { ViewerAuthProvider } from "@/context/ViewerAuthContext";
import { ViewerGate } from "@/components/ViewerGate";
import Landing from "@/pages/Landing";
import Games from "@/pages/Games";
import Watch from "@/pages/Watch";
import Library from "@/pages/Library";
import SignIn from "@/pages/SignIn";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <ViewerAuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/" element={<Landing />} />
              <Route path="/games" element={<ViewerGate><Games /></ViewerGate>} />
              <Route path="/watch/:id" element={<ViewerGate><Watch /></ViewerGate>} />
              <Route path="/library" element={<ViewerGate><Library /></ViewerGate>} />
              <Route path="/admin/login" element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
      </ViewerAuthProvider>
    </div>
  );
}

export default App;
